export default "__VITE_ASSET__x$azPdiZ__"